<template>
  <div>
    <el-row class="percent-complete">
      <div class="status">{{ completionPercentage }}%</div>
      <div class="progress">
        <div class="bar" :style="{ width: percentage * 100 + 1 + '%' }"></div>
      </div>
    </el-row>
    <el-row v-if="completionPercentage < 100">
      <div class="display-inline-block hidden">{{ completionPercentage }}%</div>
      <router-link v-if="$allow('network', 'write')" :to="{ name: 'installation' }">
        <a class="display-inline-block body3">Add Agents</a>
      </router-link>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'SensorCoverageTableCell',
  props: {
    completed: {
      type: [String, Number]
    },
    total: {
      type: [String, Number]
    }
  },
  data () {
    return {
      percentage: 0.1
    }
  },
  mounted () {
    if (parseInt(this.total) === 0) {
      this.percentage = 0
      return
    }
    this.percentage = parseInt(this.completed) / parseInt(this.total)
  },
  computed: {
    completionPercentage () {
      return Math.ceil((this.percentage * 100).toFixed(2))
    }
  }
}
</script>

<style scoped>
.percent-complete {
  position: relative;
  height: 24px;
  margin: 0px;

  .progress {
    height: 10px;
    width: 75%;
    display: inline-block;
    background: #f0f0f0;

    .bar {
      height: 10px;
      background: #0090ff;
    }
  }

  .status {
    display: inline-block;
    width: 20%;
    font-size: 1em;
    font-weight: bold;
    line-height: 20px;
    vertical-align: middle;
  }
}

.hidden {
  visibility: hidden;
}

a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/table/cell/SensorCoverageTableCell.vue